module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH",
    attrs: {
      "id": "c_pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCTF",
    attrs: {
      "id": "c_int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1")]), _vm._v("    The Mission of Catholic Higher Education in the Age of the Corporatized University")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2")]), _vm._v("    Embodying Solidarity on Catholic Campuses: The Case of Worker Justice")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("3")]), _vm._v("    Catholic Universities, the Right to Education, and the Option for the Poor: Recruiting, Admitting, and Retaining Economically Disadvantaged Students")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("4")]), _vm._v("    Socially Responsible Investment, the Stewardship of University Resources, and Integral Ecology")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("5")]), _vm._v("    Racial Inclusion and Justice at Catholic Colleges and Universities: From Tokenism to Participation")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("6")]), _vm._v("    Gender and LGBTQ Equality in the University: A Challenge for CST in the Age of Corporatized Higher Education")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1",
    attrs: {
      "id": "c_epi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMHF",
    attrs: {
      "id": "c_app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix: Embodying Catholic Social Teaching on Campus Sample Questionnaire")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_not"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0